import * as React from 'react';
import FormattedCurrency from '../../../react/common/components/FormattedCurrency';
import { translate } from 'PyzShopUi/scripts/utils/translate';
import { withMemo } from 'PyzShopUi/scripts/react/common/hoc/withMemo';

interface IProductBasicPriceProps {
    unitName: string;
    unitAmount: number;
    unitValue: number;
    currency: string;
    displayLabel?: boolean;
}

const ProductBasicPriceComponent: React.FunctionComponent<IProductBasicPriceProps> = props => {
    const { unitName, unitAmount, unitValue, currency, displayLabel } = props;

    return (
        <div className='product-basic-price'>
            <span>{displayLabel ? `${translate('Baseprice', 'article-list')}: ` : undefined }
                ({unitAmount + ' ' + unitName} = {<FormattedCurrency price={unitValue / 100} currency={currency}/>})</span>
        </div>
    );
};

const ProductBasicPrice = withMemo(ProductBasicPriceComponent);

export default ProductBasicPrice;
